import { Component, Input } from '@angular/core';
import { MentorRewardsSummary } from 'src/app/model/mentor-rewards/mentor-rewards';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-mentor-rewards-summary',
  templateUrl: './vrm-mentor-rewards-summary.component.html',
  styleUrls: ['./vrm-mentor-rewards-summary.component.scss'],
})
export class VrmMentorRewardsSummaryComponent {
  @Input() cardTitle: string;
  @Input() rewardsData: MentorRewardsSummary;

  constructor(public cService: CommonService) {}
}
